import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contract_lines_max_line_numberService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { contractId: number }): 
  Promise<{ result: { MaxLineNumber?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.contractId)) {
      $missingRequiredInParams.push('\'contractId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      contractId: number    }) {
        if(isNil($inParams.contractId)) {
          return true; 
        }
      return false;
    }
}
